import { Icon } from '@mui/material';
import { RbToolbarActionButton, RbToolbarDateRangeField, RbToolbarMultiSelectField } from '@scmlatam/web-ui';
import type { TFunction } from 'i18next';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

const ToolbarLeft = () => {
    return (
        <>
            <div id="schedule-toolbar-left" className="flex w-20 h-[2.75rem] shrink-0 items-center text-left">
                {/* <div className="min-w-0">
          <p className="p2 truncate font-semibold text-white">
            Nombre trabajador
          </p>
          <p className="p3 truncate text-white/75">12.345.678-9</p>
        </div> */}
            </div>
        </>
    );
};

interface ToolbarRightProps {
    t: TFunction;
    period: [Dayjs | null, Dayjs | null];
    setPeriod: (period: [Dayjs | null, Dayjs | null]) => void;
    tags: { label: string; value: string; sublabel?: string }[];
    tagSelected: string[];
    setTagSelected: (tags: string[]) => void;
    searchTag: string;
    setSearchTag: (searchTag: string) => void;
    employees: { label: string; value: string; sublabel?: string }[];
    employeeSelected: string[];
    setEmployeeSelected: (employees: string[]) => void;
    searchEmployee: string;
    setSearchEmployee: (searchEmployee: string) => void;
    loading: boolean;
    search: (id_employee__in: string, id_tags__in: string, date__gte: string, date__lte: string) => Promise<void>;
    reload: () => Promise<void>;
}

const ToolbarRight = ({
    t,
    period,
    setPeriod,
    tags,
    tagSelected,
    setTagSelected,
    searchTag,
    setSearchTag,
    employees,
    employeeSelected,
    setEmployeeSelected,
    searchEmployee,
    setSearchEmployee,
    loading,
    search,
    reload,
}: ToolbarRightProps) => {
    const searchParams = new URLSearchParams(window.location.search);

    const startDate = searchParams.get('start_date');
    const endDate = searchParams.get('end_date');
    const tagIds = searchParams.get('tags');

    return (
        <div id="schedule-toolbar-right" className="flex min-w-fit shrink-0 flex-nowrap items-center justify-end gap-3">
            <div id="schedule-toolbar-period" style={{ display: 'contents' }}>
                <RbToolbarDateRangeField label={t('filter.period')} value={period} onChange={setPeriod} />
            </div>

            <div id="schedule-toolbar-tags-filter" style={{ display: 'contents' }}>
                <RbToolbarMultiSelectField
                    label={t('filter.tags')}
                    placeholder={t('filter.multi_select')}
                    value={tagSelected}
                    onChange={(value) => {
                        setTagSelected(value);
                    }}
                    options={tags}
                    search={{
                        value: searchTag,
                        onChange: setSearchTag,
                        placeholder: t('filter.search_tag'),
                    }}
                />
            </div>

            <div id="schedule-toolbar-employees-filter" style={{ display: 'contents' }}>
                <RbToolbarMultiSelectField
                    label={t('filter.employees')}
                    placeholder={t('filter.multi_select')}
                    value={employeeSelected}
                    onChange={(value) => {
                        setEmployeeSelected(value);
                    }}
                    options={employees}
                    search={{
                        value: searchEmployee,
                        onChange: setSearchEmployee,
                        placeholder: t('filter.search_employee'),
                    }}
                />
            </div>

            <div id="schedule-toolbar-actions" data-toolbar-actions="true" className="flex min-w-fit shrink-0 flex-nowrap items-center justify-end gap-3">
                <RbToolbarActionButton
                    id="schedule-toolbar-search"
                    variant="secondaryPrimary"
                    disabled={!(period[0]?.isValid() && period[1]?.isValid() && tags.length > 0) || loading}
                    loading={loading}
                    onClick={() => {
                        search(
                            employeeSelected.join(','),
                            tagSelected.join(','),
                            period[0]?.format('YYYY-MM-DD') || dayjs().startOf('month').format('YYYY-MM-DD'),
                            period[1]?.format('YYYY-MM-DD') || dayjs().endOf('month').format('YYYY-MM-DD'),
                        );
                    }}
                    style={{
                        minWidth: '64px',
                        border: '1px solid #F0C400',
                    }}
                    icon={
                        <Icon baseClassName="material-symbols-rounded" sx={{ color: '#F0C400' }}>
                            search
                        </Icon>
                    }
                />

                <RbToolbarActionButton
                    id="schedule-toolbar-refresh"
                    variant="icon"
                    disabled={!(startDate && endDate && tagIds) || loading}
                    loading={loading}
                    onClick={() => {
                        reload();
                    }}
                    icon={
                        <Icon baseClassName="material-symbols-rounded" sx={{ color: '#FFFFFF' }}>
                            refresh
                        </Icon>
                    }
                />
            </div>
        </div>
    );
};

export { ToolbarLeft, ToolbarRight };
